import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { EPaymentModes } from '../enum';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/services/general.service';
import { AppInsightsService } from 'src/app/services/app-insights.service';
import { UserSessionService } from 'src/app/services/usersession.service';

declare var Stripe: any;

@Component({
    selector: 'app-stripe-payment',
    templateUrl: './stripe-payment.component.html',
    styleUrls: ['./stripe-payment.component.scss'],
    standalone: false
})
export class StripePaymentComponent implements OnInit {
  elements;
  @Input() module;
  @Input() tenantInfo;
  @Input() customerInfo;
  @Input() stripeClientSecret = '';
  @Input() mandatoryFieldsList = [];
  @Input() PublishableKey = '';
  @Input() UnifiedAccountId = '';
  @Input() paymentMode = 0;
  @Input() enableAddressAutofill: boolean;
  @Output() emitStripeModalClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitConfirmaTokenResponse: EventEmitter<any> = new EventEmitter<any>();
  @Output() loaderStatus: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() GetChargesDetailsByIntentId:EventEmitter<any> = new EventEmitter<any>();
  @Input() isPaymentWithAutoPay;
  @Input() CCPlaceHolder;
  @Input() eftPlaceHolder;
  @Input() achPlaceHolder;
  paymentModeText = '';
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  submitButtonName: string = '';
  buttonName:string ='';
  isDisableSubmit : boolean = false;
  loaderIcon: Promise<boolean>;
  isSubmitting: boolean = false;
  isStripeReady: boolean = false;
 
  private stripe3ds: any;
  constructor(
    private renderer: Renderer2,
    private toastr: ToastrService,
    public generalService: GeneralService,
    private appInsightsService: AppInsightsService,
    private userSessionService: UserSessionService,
  ) {
     window.addEventListener('message', function(ev) {
      try{
        if (ev && ev.data.includes('"status":"requires_action"')) {
          sessionStorage.setItem('stripeChallenge', 'true')
        }
      } catch {}
    }, false);
    this.generalService.stripeMethod = this.stripeMethod.bind(this);
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.addJsToElement('https://js.stripe.com/v3/').onload = () => {
        this.stripeScript();
      }
    }, 1000);

    if (this.paymentMode == EPaymentModes.ACH) {
      this.paymentModeText = 'ACH Payment';
      this.buttonName = this.achPlaceHolder;
    } else if (this.paymentMode == EPaymentModes.DirectDebitEFT) {
      this.paymentModeText = 'EFT Payment';
      this.buttonName = this.eftPlaceHolder;
    } else {
      this.paymentModeText = 'Hosted Page Payment';
      this.buttonName = this.CCPlaceHolder;
    }
    this.submitButtonName = this.module == 2 && !this.isPaymentWithAutoPay ? this.buttonName : 'Make Payment';
  }


  addJsToElement(src: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    this.renderer.appendChild(document.body, script);
    return script;
  }

  async stripeScript(): Promise<void> {
    var stripe = Stripe(this.PublishableKey, { stripeAccount: this.UnifiedAccountId });
    this.stripe3ds = stripe;
    var elements = this.createStripeElements(stripe);
    this.elements = elements;

    this.mountPaymentElement(elements);
    if (this.paymentMode == EPaymentModes.HostedPage) {
      this.mountAddressElements(elements);
    }

    const paymentElement = elements.getElement('payment');
    paymentElement.on('change', (event) => {
      this.handlePaymentMethodChange(event, elements);
    });

    const form = document.querySelector("#payment-form");
    form.addEventListener('submit', (event) => this.submitPaymentForm(event, elements, stripe));

    if (this.isEftPayment()) {
      setTimeout(() => {
        if (this.customerInfo?.Email) {
          this.loaderStatus.emit(true);
          this.onStripePay();
        }
      }, 2000);
    }

  }
  createStripeElements(stripe) {
    const elementOptions = {
      clientSecret: this.stripeClientSecret,
      appearance: {
        theme: 'stripe'
      }
    };
    return stripe.elements(elementOptions);
  }

  mountPaymentElement(elements: any): void {
    const paymentElementOptions = {
      layout: 'tabs',
    };

    var paymentElement = elements.create('payment', {

      defaultValues: {
        billingDetails: {
          name: this.customerInfo ? (this.customerInfo.FirstName + this.customerInfo.MiddleName + this.customerInfo.LastName) : '',
          email: this.customerInfo?.Email ?? '',
        }
      }
    });
    paymentElement.on('ready', () => {
    this.isStripeReady = true;  // Stripe finished loading
  });
    paymentElement.mount('#payment-element');
  }

  mountAddressElements(elements) {
    const addressElementOptions = {
      mode: 'billing',
      autocomplete: {
        mode: this.enableAddressAutofill ? 'automatic' : 'disabled'
      },
      fields: {
        phone: 'always',
      },
      validation: {
        phone: {
          required: this.getMandatoryFieldValue('tdCellphone'),
        },
      },
      defaultValues: {
          address: {
            line1: '',
            line2: '',
            city: '',
            state: '',
            postal_code: '',
            country: '',
          },
          phone : ''
        }
    };
    setTimeout(() => {
      const addressElement = elements.create('address', addressElementOptions);
      addressElement.mount('#address-element');
    }, 500)
  }

  getMandatoryFieldValue(field) {
    if (!this.mandatoryFieldsList.length) {
      return 'never';
    }
    let fieldObj = this.mandatoryFieldsList.find((ele) => ele.Name == field);
    if (fieldObj && fieldObj.Required) {
      return 'always'
    }
    return 'never';
  }

  closeStripeForm() {
    this.emitStripeModalClose.emit();
    this.loaderIcon = Promise.resolve(false);
    this.isDisableSubmit = false;
  }

  onStripePay() {
    const submitButton = document.getElementById("submit") as HTMLButtonElement;
    if (submitButton) {
      this.loaderIcon = Promise.resolve(true);
      this.isDisableSubmit = true;
      submitButton.click();
      this.loaderStatus.emit(false);
    }
  }

async submitPaymentForm(event: Event, elements: any, stripe: any) {
  event.preventDefault();

  if (this.isSubmitting && this.isEftPayment) {
    return;
  } 
  this.isSubmitting = true;
  this.loaderIcon = Promise.resolve(true);
  this.isDisableSubmit = true;

  const { error: submitError } = await elements.submit();
  if (submitError) {
    this.isSubmitting = false;
    this.loaderIcon = Promise.resolve(false);
    this.isDisableSubmit = false;
    this.handleError(submitError);
    return;
  }
  let returnTokenOrPaymentMethod = '';
  let errorData;
  if (this.module == 2) {
    const { setupIntent, error } = await stripe.confirmSetup({
      elements,
      params: {
        payment_method_data: {
          billing_details: {
              name: this.customerInfo.FirstName + this.customerInfo.MiddleName + this.customerInfo.LastName,
            email: this.customerInfo.Email,
          },
        },
      },
      redirect: 'if_required'
    });
    const ischallengeflow=sessionStorage.getItem('stripeChallenge');
    if (setupIntent && this.paymentMode == EPaymentModes.HostedPage && ischallengeflow) {
      this.toastr.warning('Cannot set this card requiring 3DS for Auto CC. Please use different card', '', this.toasterConfig);
      this.isSubmitting = false;
    this.loaderIcon = Promise.resolve(false);
    this.isDisableSubmit = false;
    this.closeStripeForm()
    sessionStorage.removeItem('stripeChallenge')
    return;
    }
    else{
          returnTokenOrPaymentMethod = setupIntent;
    }
    errorData = error;
  } else {
    this.appInsightsService.logPaymentEvent(true, `Calling createConfirmationToken response.`, { Gateway: 204 , FacilityId : this.userSessionService.userSessionData.LastAccessedStoreId, UserId : this.userSessionService.userSessionData.UserId});
      const { error, confirmationToken } = await stripe.createConfirmationToken({
        elements
      });
    returnTokenOrPaymentMethod = confirmationToken;
    this.appInsightsService.logPaymentEvent(true, `Received createConfirmationToken response.`, { Gateway: 204 , FacilityId : this.userSessionService.userSessionData.LastAccessedStoreId, UserId : this.userSessionService.userSessionData.UserId});
    errorData = error;
  }
  if (errorData) {
    this.handleError(errorData);
    this.isSubmitting = false;
    this.loaderIcon = Promise.resolve(false);
    this.isDisableSubmit = false;
    return;
  }
  this.handlestripeToken(returnTokenOrPaymentMethod);
}

  handleError(error) {
    const errorMessage = error?.message ?? 'Failed to receive confirmation token';
    this.toastr.warning(errorMessage, 'Payment Error', this.toasterConfig);
  }

  handlestripeToken(confirmationToken) {
    this.emitConfirmaTokenResponse.emit(confirmationToken);
  }

  handlePaymentMethodChange(event: any, elements) {
    if (event.value) {
      const addressElementContainer = document.getElementById('address-element');
      const addressElement = elements.getElement('address');

      if (event.value.type === 'card') {
        if (addressElementContainer && !addressElementContainer.hasChildNodes()) {
          addressElement.mount('#address-element');
        }
      } else if (addressElement) {
        addressElement.unmount();
      }
    }
  }

  onClickAutoPopulateBillingInfo(checked) {
    let addressElement = this.elements.getElement('address');
    if (checked) {
      if (this.customerInfo) {
        if (addressElement) {
          addressElement.unmount();
          addressElement.destroy(); // Destroy the previous element
        }
        setTimeout(() => {
          const addressElementOptions = this.getAddressElementOptions(false);
          addressElement = this.elements.create('address', addressElementOptions);
          addressElement.mount('#address-element');
        }, 500);
      }
    } else {
      if (addressElement) {
        addressElement.unmount();
        addressElement.destroy();

        setTimeout(() => {
          const addressElementOptions = this.getAddressElementOptions(true);
          addressElement = this.elements.create('address', addressElementOptions);
          addressElement.mount('#address-element');
        }, 500);
      }
    }
  }

  isEftPayment(): boolean {
    return this.paymentMode == EPaymentModes.DirectDebitEFT || this.paymentMode == EPaymentModes.DirectDebitEFTOnFile;
  }

  isAchOrEftPayment(): boolean {
    return this.paymentMode == EPaymentModes.DirectDebitEFT || this.paymentMode == EPaymentModes.ACH || this.paymentMode == EPaymentModes.ACHOnFile || this.paymentMode == EPaymentModes.DirectDebitEFTOnFile;
  }


  getAddressElementOptions(isClear) {
    if (isClear) {
      return {
        mode: 'billing',
        fields: {
          phone: 'always',
        },
        defaultValues: {
          name: '',
          address: {
            line1: '',
            line2: '',
            city: '',
            state: '',
            postal_code: '',
            country: '',
          }
        }
      };
    } else {
      return {
        mode: 'billing',
        fields: {
          phone: 'always',
        },
        defaultValues: {
          name: this.customerInfo.FirstName + ' ' + this.customerInfo.MiddleName + ' ' + this.customerInfo.LastName,
          address: {
            line1: this.customerInfo.AddressOne ? this.customerInfo.AddressOne : this.tenantInfo && this.tenantInfo.Address ? this.tenantInfo.Address : "",
            line2: '',
            city: this.customerInfo.City ? this.customerInfo.City : this.tenantInfo && this.tenantInfo.City ? this.tenantInfo.City : "",
            state: this.customerInfo.StateCode ? this.customerInfo.StateCode : this.tenantInfo && this.tenantInfo.State?.Code ? this.tenantInfo.State?.Code : "",
            postal_code: this.customerInfo.PostalCode ? this.customerInfo.PostalCode : this.tenantInfo && this.tenantInfo.Zip ? this.tenantInfo.Zip : "",
            country: this.customerInfo.CountryCode,
          },
        }
      };
    }
  }

  stripeMethod(key, ClientSecret) {

    this.stripe3ds.handleNextAction({
      clientSecret: ClientSecret
    }).then(({ paymentIntent, error }) => {
      if (error) {
        this.elements?.getElement('payment')?.unmount();
        this.elements?.getElement('address')?.unmount();
        this.elements = null;
        this.stripe3ds = null;
        const form = document.querySelector('#payment-form');
        if (form) form.remove();
        this.GetChargesDetailsByIntentId.emit();
      } else {
        if (paymentIntent.status === 'succeeded' || paymentIntent.status === 'requires_capture') {
          this.GetChargesDetailsByIntentId.emit();
        }
      }
    });

  }
}
